module.exports = __webpack_public_path__ + "6bcf9bdd606dcf6222399acd7501ca36.png";